import { createContext, useContext, useState } from "react";

// One in-memory price visibility flag per pitch session; resets on refresh.
const PriceVisibilityContext = createContext({ revealed: false, toggle: () => {} });

export const PriceVisibilityProvider = ({ children }) => {
  const [revealed, setRevealed] = useState(false);
  return (
    <PriceVisibilityContext.Provider value={{ revealed, toggle: () => setRevealed((v) => !v) }}>
      {children}
    </PriceVisibilityContext.Provider>
  );
};

export const usePriceVisibility = () => useContext(PriceVisibilityContext);
